import { useContext } from 'react';
import { MainCouranteContext } from './MainCouranteContext';

export function useMainCourante() {
  const context = useContext(MainCouranteContext);
  if (context === undefined) {
    throw new Error('useMainCourante must be used within a MainCouranteProvider');
  }
  return context;
}
